export class TaakTipAantal {

  static deserialize(dto: TaakTipAantalDto): TaakTipAantal {
    return new TaakTipAantal(
      dto.categorieId,
      dto.taakId,
      dto.aantalAlgemeneTips,
      dto.aantalClientTips,
    );
  }

  constructor(
    private categorieId: string,
    private taakId: string,
    private aantalAlgemeneTips: number,
    private aantalClientTips: number,
  ) {
  }

  getCategorieId(): string {
    return this.categorieId;
  }

  hasCategorieId(categorieId: string): boolean {
    return this.categorieId === categorieId;
  }

  getTaakId(): string {
    return this.taakId;
  }

  hasTaakId(taakId: string): boolean {
    return this.taakId === taakId;
  }

  getAantalAlgemeneTips(): number {
    return this.aantalAlgemeneTips;
  }

  getAantalClientTips(): number {
    return this.aantalClientTips;
  }

  getTotaalAantalTips(): number {
    return this.getAantalAlgemeneTips() + this.getAantalClientTips();
  }
}

export interface TaakTipAantalDto {
  categorieId: string;
  taakId: string;
  aantalAlgemeneTips: number;
  aantalClientTips: number;
}
